// Service-specific intake fields configuration.
// type: 'text' | 'textarea' | 'select' | 'multi'
// Renders inside the customer "New Request" modal when the service is selected.

export const SERVICE_FORM_CONFIG = {
  "svc-plumber": [
    {
      key: "issue_type",
      label: "Type of issue",
      type: "select",
      options: ["Tap / Faucet", "Pipe leak", "Drain blockage", "Toilet", "Geyser", "Water tank", "Other"],
      required: true,
    },
    { key: "urgency", label: "Urgency", type: "select", options: ["Emergency", "Within 24 hrs", "Flexible"] },
  ],
  "svc-electrician": [
    {
      key: "issue_type",
      label: "Type of issue",
      type: "select",
      options: ["Wiring", "Switch / Socket", "Fan / Light", "Inverter / UPS", "MCB / Fuse", "Appliance install", "Other"],
      required: true,
    },
    { key: "urgency", label: "Urgency", type: "select", options: ["Emergency", "Within 24 hrs", "Flexible"] },
  ],
  "svc-carpenter": [
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["Repair", "New furniture", "Door / Window", "Modular kitchen", "Polishing", "Other"],
      required: true,
    },
  ],
  "svc-mason": [
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["Tiling", "Plastering", "Brick / Wall work", "Waterproofing", "Renovation", "Other"],
      required: true,
    },
    { key: "area_sqft", label: "Approx area (sqft)", type: "text", placeholder: "e.g. 200" },
  ],
  "svc-house-maid": [
    {
      key: "frequency",
      label: "Frequency",
      type: "select",
      options: ["Daily", "Weekly", "One-time", "Live-in"],
      required: true,
    },
    {
      key: "tasks",
      label: "Tasks needed",
      type: "multi",
      options: ["Sweeping & mopping", "Utensils", "Cooking", "Laundry", "Babysitting", "Elderly care"],
      required: true,
    },
  ],
  "svc-beautician": [
    { key: "gender", label: "For", type: "select", options: ["Female", "Male", "Kids"], required: true },
    {
      key: "services_needed",
      label: "Services",
      type: "multi",
      options: ["Haircut", "Facial", "Mehendi", "Manicure", "Pedicure", "Makeup", "Waxing", "Threading", "Hair color"],
      required: true,
    },
  ],
  "svc-gardener": [
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["Garden setup", "Maintenance", "Lawn mowing", "Plant care", "Tree pruning"],
      required: true,
    },
    { key: "frequency", label: "Frequency", type: "select", options: ["One-time", "Weekly", "Monthly"] },
  ],
  "svc-ro-service": [
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["Installation", "Repair", "Filter change", "AMC / Yearly service"],
      required: true,
    },
    { key: "brand", label: "RO brand (if known)", type: "text", placeholder: "Kent, Aquaguard, Pureit..." },
  ],
  "svc-ac-fridge": [
    {
      key: "appliance",
      label: "Appliance",
      type: "select",
      options: ["AC - Window", "AC - Split", "AC - Cassette", "Fridge - Single door", "Fridge - Double door", "Fridge - Side by side"],
      required: true,
    },
    {
      key: "tonnage",
      label: "AC Tonnage",
      type: "select",
      options: ["0.75 Ton", "1 Ton", "1.5 Ton", "2 Ton", "Not applicable"],
    },
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["Installation", "Repair", "Gas refill", "General service / AMC", "Uninstall / Shift"],
      required: true,
    },
    { key: "brand", label: "Brand (if known)", type: "text", placeholder: "LG, Voltas, Daikin..." },
  ],
  "svc-washing-machine": [
    {
      key: "machine_type",
      label: "Machine type",
      type: "select",
      options: ["Top Load - Fully Auto", "Front Load", "Semi-Auto", "Not sure"],
      required: true,
    },
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["Installation", "Repair", "General service"],
      required: true,
    },
    { key: "brand", label: "Brand (if known)", type: "text", placeholder: "LG, Samsung, IFB..." },
  ],
  "svc-cctv": [
    {
      key: "work_type",
      label: "Type of work",
      type: "select",
      options: ["New installation", "Repair / fault", "Add more cameras", "DVR / NVR issue"],
      required: true,
    },
    { key: "num_cameras", label: "Number of cameras", type: "text", placeholder: "e.g. 4" },
  ],
  "svc-fire-cylinder": [
    {
      key: "action",
      label: "Action",
      type: "select",
      options: ["Refill", "Inspection / Audit", "New cylinder purchase", "Service"],
      required: true,
    },
    {
      key: "cylinder_type",
      label: "Cylinder type",
      type: "select",
      options: ["ABC powder 1kg", "ABC powder 2kg", "ABC powder 4kg", "ABC powder 6kg", "CO2", "Foam", "Other"],
    },
  ],
  "svc-car-driver": [
    {
      key: "duration",
      label: "Duration",
      type: "select",
      options: ["Hourly", "Half-day", "Full-day", "Outstation"],
      required: true,
    },
    {
      key: "car_type",
      label: "Car type",
      type: "select",
      options: ["Hatchback", "Sedan", "SUV", "MUV", "Luxury"],
      required: true,
    },
    { key: "when", label: "When", type: "text", placeholder: "Tomorrow 9 AM" },
  ],
  "svc-taxi-booking": [
    {
      key: "vehicle",
      label: "Vehicle",
      type: "select",
      options: ["Taxi - Hatchback", "Taxi - Sedan", "Taxi - SUV", "Bike", "Tempo Traveller", "Bus"],
      required: true,
    },
    { key: "pickup", label: "Pickup location", type: "text", required: true, placeholder: "Origin" },
    { key: "drop", label: "Drop location", type: "text", required: true, placeholder: "Destination" },
    { key: "when", label: "Pickup time", type: "text", placeholder: "Today 6 PM" },
    { key: "passengers", label: "Passengers", type: "text", placeholder: "e.g. 3" },
  ],
  "svc-grocery": [
    { key: "items", label: "Items needed", type: "textarea", required: true, placeholder: "List groceries and quantities..." },
    { key: "store_pref", label: "Preferred store", type: "text", placeholder: "Big Bazaar, local kirana..." },
    { key: "when", label: "Deliver by", type: "text", placeholder: "Today evening" },
  ],
};

export const getFieldsForService = (serviceId) => SERVICE_FORM_CONFIG[serviceId] || [];

// Per-service hint text for the generic "Describe your issue / requirement" textarea
const DESCRIPTION_HINTS = {
  "svc-plumber": "e.g. Kitchen sink leaking from the joint near the wall",
  "svc-electrician": "e.g. Ceiling fan stopped working in the bedroom",
  "svc-carpenter": "e.g. Need a new wardrobe with sliding doors in master bedroom",
  "svc-mason": "e.g. Bathroom needs re-tiling, around 60 sqft",
  "svc-house-maid": "e.g. Need someone for daily 2 hrs — sweeping, mopping, utensils",
  "svc-beautician": "e.g. Bridal makeup + mehendi at home on Saturday evening",
  "svc-home-tutor": "e.g. Need a tutor 3 days a week, 1 hour each, evenings preferred",
  "svc-gardener": "e.g. Weekly maintenance for a 200 sqft balcony garden",
  "svc-ro-service": "e.g. RO is making noise and water tastes salty — need filter check",
  "svc-ac-fridge": "e.g. 1.5 Ton split AC not cooling enough, makes a rattling sound",
  "svc-washing-machine": "e.g. Front load washing machine not draining after wash cycle",
  "svc-cctv": "e.g. Install 4 cameras (1 entrance, 2 hallway, 1 backyard) + DVR with phone access",
  "svc-fire-cylinder": "e.g. 2 ABC 4kg cylinders need annual refill at office",
  "svc-car-driver": "e.g. Need a driver tomorrow 9 AM – 6 PM for local meetings in Sedan",
  "svc-taxi-booking": "e.g. SUV from Delhi airport to Gurgaon on 5 Aug, 11 PM, 4 passengers",
  "svc-grocery": "e.g. Weekly groceries — atta 10kg, rice 5kg, milk 4L, vegetables for week",
};

export const getDescriptionHint = (serviceId) =>
  DESCRIPTION_HINTS[serviceId] || "Briefly describe what you need";
